import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import Authenticate from 'src/modules/account/components/Authenticate';
import '@aws-amplify/ui-react/styles.css';

const Layout = ({ children }) => {
  return (
    <Authenticator.Provider>
      <Authenticate>
        <div className="flex">{children}</div>
      </Authenticate>
    </Authenticator.Provider>
  );
};

export default Layout;
